import script from "./BlockInputEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockInputEmail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__